
export default {
  'main.title': '车队云管理',
  'menu.webhook': '数据推送',
  'menu.drivelog': '驾驶日志',
   'menu.attendance': '打卡记录',
  'home.home': '首页',
  'user.email': '邮箱',
  'user.input.keyboard.error': '请将键盘输入法设置为半角模式',
  'user.email.tip': '请输入邮箱地址',
  'user.password': '密码',
  'user.reg': '注册',
  'user.reg.success': '注册成功',
  'user.reg.fail': '注册失败',
  'user.reg.success.description': '即将返回登录页面',
  'user.regnow': '立即注册',
  'user.login': '登录',
  'user.name.change.title': '修改姓名',
  'user.name.new': '姓名',
  'user.name.new.tip': '请输入新的姓名',
  'user.signout': '注销登录',
  'user.captcha': '验证码',
  'user.slider.title': '安全验证',
  'user.slider.drag': '拖动滑块完成拼图',
  'user.slider.loading': '加载中...',
  'user.slider.moving': '松开验证',
  'user.slider.verifying': '验证中...',
  'user.slider.success': '验证成功',
  'user.slider.error': '验证失败，请重试',
  'user.slider.loadFailed': '图片加载失败，点击重试',
  'user.signInGoogle': '使用Google登录',
  'user.google.unavailable': '无法连接 Google 登录服务，请改用邮箱和密码登录',
  'user.emailCaptcha': '邮箱验证码',
  'user.emailCaptcha.tip': '请输入邮箱验证码',
  'user.getCaptcha': '获取验证码',
  'user.readAndAgree': '我已阅读并同意',
  'user.UserServiceAgreement': '用户服务协议',
  'user.action.delete': '删除',
  'user.action.more': '更多操作',
  'user.action.save': '保存',
  'user.action.save.success': '保存成功',
  'user.action.save.fail': '保存失败',
  'menu.record': '测试记录',
  'menu.organization': '组织管理',
  'menu.accident': '事故管理',
  'menu.training': '讲习管理',
  'menu.worklog': '作业日志',
  'org.my.title': '我的组织',
  'org.my.tip': '适用于大中型有多级组织架构的企业，小企业无需维护。',
  'org.refresh': '刷新',
  'org.name': '组织名称',
  'org.id': '组织ID',
  'org.invite.code': '邀请码',
  'org.create.time': '创建时间',
  'org.copy': '复制',
  'org.copy.success': '邀请码已复制',
  'org.copy.fail': '复制失败,请手动复制',
  'org.create.title': '创建组织',
  'org.create.tip': '创建一个新组织,创建后你将自动成为其成员',
  'org.create.placeholder': '请输入组织名称',
  'org.create.name.required': '请输入组织名称',
  'org.create.button': '创建组织',
  'org.create.top.limit.tip': '只能创建一个一级组织',
  'org.create.success': '组织创建成功',
  'org.create.fail': '组织创建失败',
  'org.join.title': '加入组织',
  'org.join.tip': '输入组织邀请码即可加入',
  'org.join.placeholder': '请输入组织邀请码',
  'org.join.code.required': '请输入组织邀请码',
  'org.join.button': '加入组织',
  'org.join.success': '加入组织成功',
  'org.join.fail': '加入组织失败',
  'org.admin.count': '管理员数',
  'org.driver.count': '司机数',
  'org.action': '操作',
  'org.invite.admin': '邀请管理员',
  'org.invite.success': '邀请码已复制，可发送给需要加入的管理员',
  'org.invite.fail': '复制失败，请手动复制',
  'org.create.modal.title': '创建新组织',
  'org.create.sub.button': '添加下级组织',
  'org.create.sub.modal.title': '在 {name} 下创建下级组织',
  'org.create.sub.placeholder': '请输入下级组织名称',
  'org.delete.button': '删除',
  'org.delete.modal.title': '删除组织',
  'org.delete.confirm.prefix': '请输入组织名称',
  'org.delete.confirm.suffix': '以确认删除，此操作不可恢复。',
  'org.delete.confirm.placeholder': '请输入组织名称',
  'org.delete.name.not.match': '组织名称输入不一致',
  'org.delete.success': '组织删除成功',
  'org.delete.fail': '组织删除失败',
  'org.rename.button': '修改名称',
  'org.rename.modal.title': '修改组织名称',
  'org.rename.placeholder': '请输入新的组织名称',
  'org.rename.name.required': '请输入组织名称',
  'org.rename.success': '组织名称修改成功',
  'org.rename.fail': '组织名称修改失败',
  'org.add.admin.button': '添加管理员',
  'org.add.admin.modal.title': '添加管理员',
  'org.add.admin.tip': '直接创建该组织的管理员账号，创建后自动加入该组织。',
  'org.add.admin.account.placeholder': '请输入邮箱',
  'org.add.admin.account.required': '请输入邮箱',
  'org.add.admin.account.format': '请输入正确的邮箱格式',
  'org.add.admin.passwd.placeholder': '请输入密码(至少6位)',
  'org.add.admin.passwd.min': '密码至少6位',
  'org.add.admin.name.placeholder': '请输入姓名(可选)',
  'org.add.admin.success': '管理员创建成功',
  'org.add.admin.fail': '管理员创建失败',
  'org.admins.modal.title': '管理员管理',
  'org.admins.modal.title.with.org': '管理员管理 - {name}',
  'org.admins.tip': '管理该组织的管理员',
  'org.admins.status': '状态',
  'org.admins.creator': '创建者',
  'org.admins.rename': '修改姓名',
  'org.admins.reset.pwd': '重置密码',
  'org.admins.reset.pwd.modal.title': '重置管理员密码',
  'org.admins.reset.pwd.placeholder': '请输入新密码',
  'org.admins.reset.pwd.min': '密码长度不能少于6位',
  'org.admins.reset.pwd.success': '密码已重置',
  'org.admins.reset.pwd.fail': '密码重置失败',
  'org.admins.rename.modal.title': '修改管理员姓名',
  'org.admins.rename.placeholder': '请输入新的姓名',
  'org.admins.rename.name.required': '请输入姓名',
  'org.admins.rename.success': '姓名修改成功',
  'org.admins.rename.fail': '姓名修改失败',
  'org.admins.delete': '删除',
  'org.admins.delete.confirm': '确定删除该管理员吗？',
  'org.admins.delete.success': '管理员已删除',
  'org.admins.delete.fail': '删除失败',
  'org.admins.status.success': '状态已更新',
  'org.admins.status.fail': '状态更新失败',
  'org.admins.load.fail': '加载管理员列表失败',
  'org.drivers.modal.title': '司机列表',
  'org.drivers.modal.title.with.org': '司机列表 - {name}',
  'org.drivers.bind.time': '绑定时间',
  'org.drivers.load.fail': '加载司机列表失败',
  'org.drivers.add': '添加司机',
  'org.drivers.add.modal.title': '添加司机',
  'org.drivers.add.account.placeholder': '请输入账号',
  'org.drivers.add.account.required': '请输入账号',
  'org.drivers.add.passwd.placeholder': '请输入密码',
  'org.drivers.add.passwd.min': '密码长度不能少于6位',
  'org.drivers.add.name.placeholder': '请输入姓名',
  'org.drivers.add.success': '司机已添加',
  'org.drivers.add.fail': '司机添加失败',
  'org.account.checking': '检测中…',
  'org.account.available': '该账户名可用',
  'org.account.taken': '该账户名已被占用，请更换其他账户名',
  'org.account.invalid': '账户名包含不支持的字符',
  'org.account.email': '账户名必须是邮箱格式',
  'org.logs.button': '操作记录',
  'org.logs.modal.title': '操作记录',
  'org.logs.modal.title.with.org': '操作记录 - {name}',
  'org.logs.time': '时间',
  'org.logs.operator': '操作人',
  'org.logs.action': '操作类型',
  'org.logs.target': '目标对象',
  'org.logs.detail': '详情',
  'org.logs.load.fail': '加载操作记录失败',
  'org.logs.org': '组织',
  'org.logs.action.org.create': '创建组织',
  'org.logs.action.org.create_sub': '创建下级组织',
  'org.logs.action.org.rename': '修改组织名称',
  'org.logs.action.org.delete': '删除组织',
  'org.logs.action.admin.create': '添加管理员',
  'org.logs.action.admin.delete': '删除管理员',
  'org.logs.action.admin.rename': '修改管理员姓名',
  'org.logs.action.admin.status': '禁用/启用管理员',
  'org.logs.action.admin.reset.pwd': '重置管理员密码',
  'org.logs.action.admin.org.change': '修改管理员所在组织',
  'org.logs.action.driver.create': '添加司机',
  'org.logs.action.driver.delete': '删除司机',
  'org.logs.action.driver.rename': '修改司机姓名',
  'org.logs.action.driver.org.change': '移入其他组织',
  'org.logs.action.driver.status': '禁用/启用司机',
  'org.drivers.selected': '已选 {count} 项',
  'org.drivers.delete': '删除',
  'org.drivers.delete.confirm': '确定删除选中的司机吗？',
  'org.drivers.delete.success': '司机已删除',
  'org.drivers.delete.fail': '删除失败',
  'org.drivers.disable': '禁用',
  'org.drivers.enable': '启用',
  'org.drivers.disable.confirm': '确定禁用选中的司机吗？',
  'org.drivers.status.success': '状态已更新',
  'org.drivers.status.fail': '状态更新失败',
  'org.drivers.rename': '修改姓名',
  'org.drivers.rename.modal.title': '修改司机姓名',
  'org.drivers.rename.placeholder': '请输入新的姓名',
  'org.drivers.rename.name.required': '请输入姓名',
  'org.drivers.rename.success': '姓名修改成功',
  'org.drivers.rename.fail': '姓名修改失败',
  'org.drivers.change.org': '移入其他组织',
  'org.drivers.change.org.modal.title': '移入其他组织',
  'org.drivers.change.org.placeholder': '请选择目标组织',
  'org.drivers.change.org.required': '请选择目标组织',
  'org.drivers.change.org.success': '已移入目标组织',
  'org.drivers.change.org.fail': '移入失败',
  'org.drivers.change.org.noAdmin.title': '目标组织暂无管理员',
  'org.drivers.change.org.noAdmin.content': '目标组织「{name}」暂无管理员，无法移入司机。请先为该组织添加管理员。',
  'org.drivers.change.org.noAdmin.ok': '去添加管理员',
  'org.drivers.change.org.noAdmin.cancel': '取消',
  'org.admins.change.org': '修改组织',
  'org.admins.change.org.modal.title': '修改管理员所在组织',
  'org.admins.change.org.placeholder': '请选择目标组织',
  'org.admins.change.org.required': '请选择目标组织',
  'org.admins.change.org.success': '已修改管理员所在组织',
  'org.admins.change.org.fail': '修改失败',
  'org.join.modal.title': '加入组织',
  'org.join.searching': '正在查询组织信息...',
  'org.join.org.name': '对应组织：{name}',
  'org.join.not.found': '未找到对应的组织',
  'org.empty.tip': '还没有加入任何组织',
  'accident.search.title': '事故检索',
  'accident.field.driver': '司机',
  'accident.field.name': '司机姓名',
  'accident.field.type': '事故类型',
  'accident.field.time': '事故时间',
  'accident.field.location': '事故地点',
  'accident.field.summary': '事故概要',
  'accident.field.reason': '事故原因',
  'accident.field.countermeasure': '再发防止对策',
  'accident.field.action': '操作',
  'accident.type.1': '普通事故',
  'accident.type.2': '普通死伤事故',
  'accident.type.3': '重大事故（≥2人死亡）',
  'accident.action.search': '搜索',
  'accident.action.reset': '重置',
  'accident.action.create': '添加事故',
  'accident.action.export': '导出Excel',
  'accident.action.edit': '编辑',
  'accident.action.delete': '删除',
  'accident.action.cancel': '取消',
  'accident.modal.create.title': '添加事故',
  'accident.modal.edit.title': '编辑事故',
  'accident.form.user_id.tip': '请选择司机',
  'accident.form.user_id.placeholder': '请选择司机',
  'accident.form.type.tip': '请选择事故类型',
  'accident.form.type.placeholder': '请选择事故类型',
  'accident.form.time.tip': '请选择事故时间',
  'accident.form.time.placeholder': '请选择事故时间',
  'accident.form.location.placeholder': '请输入事故地点',
  'accident.form.summary.placeholder': '请输入事故概要',
  'accident.form.reason.placeholder': '请输入事故原因',
  'accident.form.countermeasure.placeholder': '请输入再发防止对策',
  'accident.message.save.success': '保存成功',
  'accident.message.save.fail': '保存失败',
  'accident.message.delete.success': '删除成功',
  'accident.message.delete.fail': '删除失败',
  'accident.delete.confirm.title': '删除事故记录',
  'accident.delete.confirm.content': '确定要删除该事故记录吗？',
  'accident.export.filename': '事故列表',
  'accident.export.loading': '正在导出...',
  'accident.export.fail': '导出失败',
  'training.search.title': '讲习检索',
  'training.field.driver': '司机',
  'training.field.name': '司机姓名',
  'training.field.date': '讲习结业日期',
  'training.field.content': '讲习内容',
  'training.field.action': '操作',
  'training.action.search': '搜索',
  'training.action.reset': '重置',
  'training.action.create': '添加讲习',
  'training.action.export': '导出Excel',
  'training.action.edit': '编辑',
  'training.action.delete': '删除',
  'training.action.cancel': '取消',
  'training.modal.create.title': '添加讲习',
  'training.modal.edit.title': '编辑讲习',
  'training.form.user_id.tip': '请选择司机',
  'training.form.user_id.placeholder': '请选择司机',
  'training.form.date.tip': '请选择讲习结业日期',
  'training.form.date.placeholder': '请选择讲习结业日期',
  'training.form.content.placeholder': '请输入讲习内容',
  'training.message.save.success': '保存成功',
  'training.message.save.fail': '保存失败',
  'training.message.delete.success': '删除成功',
  'training.message.delete.fail': '删除失败',
  'training.delete.confirm.title': '删除讲习记录',
  'training.delete.confirm.content': '确定要删除该讲习记录吗？',
  'training.export.filename': '讲习列表',
  'training.export.loading': '正在导出...',
  'training.export.fail': '导出失败',
  'training.notice.expired': '以下司机距上次讲习结业日已超过1年11个月，请尽快安排讲习：',
  'worklog.search.title': '作业日志检索',
  'worklog.filter.work_date': '业务日期',
  'worklog.field.driver': '司机',
  'worklog.field.name': '司机姓名',
  'worklog.field.plate': '车牌',
  'worklog.field.work_start': '业务开始时间',
  'worklog.field.work_end': '业务结束时间',
  'worklog.field.work_location': '业务地点',
  'worklog.field.rest_time': '休息时间',
  'worklog.field.rest_location': '休息地点',
  'worklog.field.distance': '行驶距离(km)',
  'worklog.field.waypoints': '途经地点',
  'worklog.field.action': '操作',
  'worklog.action.search': '搜索',
  'worklog.action.reset': '重置',
  'worklog.action.create': '添加作业日志',
  'worklog.action.export': '导出Excel',
  'worklog.action.edit': '编辑',
  'worklog.action.delete': '删除',
  'worklog.action.cancel': '取消',
  'worklog.modal.create.title': '添加作业日志',
  'worklog.modal.edit.title': '编辑作业日志',
  'worklog.form.user_id.tip': '请选择司机',
  'worklog.form.user_id.placeholder': '请选择司机',
  'worklog.form.plate.tip': '请输入车牌',
  'worklog.form.plate.placeholder': '请输入车牌',
  'worklog.form.work_start.tip': '请选择业务开始时间',
  'worklog.form.work_start.placeholder': '请选择业务开始时间',
  'worklog.form.work_end.tip': '请选择业务结束时间',
  'worklog.form.work_end.early': '业务结束时间不能早于业务开始时间',
  'worklog.form.work_end.placeholder': '请选择业务结束时间',
  'worklog.form.work_location.placeholder': '请输入业务地点',
  'worklog.form.rest_time.placeholder': '如 12:00~13:00 或 1小时',
  'worklog.form.rest_location.placeholder': '请输入休息地点',
  'worklog.form.distance.placeholder': '请输入行驶距离(km)',
  'worklog.form.waypoints.placeholder': '请输入途经地点，多个地点用顿号分隔',
  'worklog.message.save.success': '保存成功',
  'worklog.message.save.fail': '保存失败',
  'worklog.message.delete.success': '删除成功',
  'worklog.message.delete.fail': '删除失败',
  'worklog.delete.confirm.title': '删除作业日志',
  'worklog.delete.confirm.content': '确定要删除该作业日志吗？',
  'worklog.export.filename': '作业日志列表',
  'worklog.export.loading': '正在导出...',
  'worklog.export.fail': '导出失败',
  'menu.driver': '司机管理',
  'menu.title': '车队云管理',
  'menu.daily.data': '数据日报',
  'user.accountSetting': '账户设置',
  'user.tip': '提示',
  'user.signOutTip': '真的要注销登录吗 ?',
  'table.emptyText': '暂无数据',
  'table.selected': '已选 {count} 条',
  'user.bind.num': '共绑定{count}人',
  'user.alc.test.num': '{count}人进行了酒精测试',
  'user.action': '操作',
  'user.name': '姓名',
  'user.org.name': '组织',
  'user.name.tip': '请输入姓名',
  'user.account': '账号',
  'user.account.format': '账号只能包含字母和数字，至少5个字符',
  'user.account.min.length': '账号至少6位字符',
  'user.bindTime': '绑定时间',
  'user.action.search': '搜索',
  'user.action.bind': '绑定司机',
  'user.action.driverCreate': '创建司机账户',
  'user.action.driverCreate.success': '司机账户创建成功',
  'user.action.driverCreate.fail': '司机账户创建失败',
  'user.action.qrWinOpenTip': '请勿在司机扫码授权完成前关闭该窗口。',
  'user.action.scanBind': '通过扫描二维码绑定司机',
  'user.action.emailBind': '通过输入管理员邮箱绑定司机',
  'user.visit.tip': '请当面邀请司机扫描该二维码。',
  'user.action.bind.success': '司机绑定成功',
  'user.test.id': '序列号',
  'user.test.value': '检测值(mg/L)',
  'user.test.date': '检测日期',
  'user.test.time': '检测时间',
  'user.id': '司机ID',
  'user.test.appraise': '评估',
  'user.test.user': '测试人',
  'user.test.image': '照片',
  'user.test.appraise.yes': '安全',
  'user.test.appraise.no': '危险',
  'user.test.appraise.warn': '警告',
  'user.car.license_plate_number': '车牌号',
  'user.action.download': '下载',
  'user.action.download.tip': '请选择需要下载的记录',
  'user.action.download.success': '下载数据成功',
  'user.action.download.fail': '下载数据失败',
  'user.action.export': '导出',
  'user.action.export.tip': '请选择要导出的记录',
  'user.action.export.success': '导出成功',
  'user.action.export.fail': '导出失败',
  'user.share.status': '共享状态',
  'user.share.status.enable': '启用',
  'user.share.status.disable': '禁用',
  'user.share.status.disable.tip': '该司机已被禁用，如需恢复请在操作列点击启用',
  'user.action.delete.tip': '确认删除吗？',
  'user.action.delete.yes': '是',
  'user.action.delete.no': '否',
  'user.password.change.password': '重置密码',
  'user.password.change.password.tip': '请输入密码',
  'user.password.change.passwordReview': '确认密码',
  'user.password.change.password.not.match': '两次输入密码不一致',
  'user.action.ok': '确认',
  'user.action.cancel': '取消',
  'user.password.change.ok': '保存',
  'user.password.change.cancel': '取消',
  'user.password.change.password.current': '当前密码',
  'user.password.change.password.new': '新密码',
  'user.password.change.password.new.tip': '请输入新密码',
  'user.password.change.password.current.tip': '请输入当前密码',
  'user.password.change.passwordReview.new': '确认新密码',
  'user.password.change.passwordReview.new.tip': '请再次输入相同的新密码',
  'user.password.change.password.format.error': '密码必须为字母数字混合，长度为8-20',
  'user.password.level': '强度',
  'user.password.level.low': '低',
  'user.password.level.medium': '中',
  'user.password.level.high': '高',
  'user.password.level.error': '密码强度不够',
  'user.password.level.tip': ' 请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  'user.account.login': '使用已有账户登录',
  'user.password.format.tip': '至少6位密码，区分大小写',
  'user.password.min.length': '密码至少6位字符',
  'user.email.captcha.send': '验证码发送中..',
  'user.email.captcha.send.success': '验证码发送成功，请查收邮箱',
  'user.email.captcha.send.fail': '验证码发送失败，请重试',
  'user.email.captcha.required': '请先获取验证码',
  'user.email.captcha.error': '验证码错误，请重试',
  'user.password.confirm': '确认密码',
  'user.password.confirm.tip': '请再次输入密码',
  'user.password.confirm.error': '两次输入的密码不一致',
  'user.password.reset': '重置密码',
  'user.password.reset.success': '密码重置成功',
  'user.password.reset.fail': '密码重置失败',
  'user.forgetPassword': '忘记密码',
  'user.welcome': '欢迎',
  'user.welcome.back': '欢迎回来',
  'user.agreement.read': '请先阅读并同意用户隐私协议',
  'user.profile': '用户信息',
  'user.car.area': '地域',
  'user.car.type': '分类番号',
  'user.car.plateName': '平板名',
  'user.car.number': '序列编号',
  'user.car.color': '颜色',
  'user.car.color.GreenWhite': '白牌緑字',
  'user.car.color.WhiteGreen': '緑牌白字',
  'user.car.color.BlackYellow': '黄牌黑字',
  'user.car.color.YellowBlack': '黑牌黄字',
  'user.car.color.GreenBlue': '蓝牌绿字',
  'user.car.color.RedWhite': '白牌红字',
  'user.membership.level': '会员等级',
  'user.membership.upgrade': '升级会员',
  'user.membership.function': '功能',
  'user.membership.function.location': '显示测试地点',
  'user.membership.function.video': '录像10秒',
  'user.membership.function.excel': 'EXCEL导出',
  'user.membership.function.email': '邮件通知',
  'user.membership.function.data.sync': '数据恢复',
  'user.membership.days': '天',
  'user.membership.pay': '支付',
  'user.membership.function.data.limit': '数据查看权限',
  'user.membership.expire.time': '会员过期时间',
  'user.share.code.checking': '正在校验授权码',
  'user.share.code.params.err': '参数错误',
  'user.share.bind.tip': '绑定获取{name}的数据授权。',
  'user.share.bind': '确定',
  'user.test.value.limited': '升级Pro或者Pro+会员才能查看测试数据',
  'user.webhook.function.tip': '此功能仅针对需要自行接收保存数据且有开发能力的用户。若您为普通用户，请忽略该页面。',
  'user.webhook.function.tip1': '若您想收到用户的测试数据，需要满足2个条件：1.目标司机用户在您的司机列表中；2.此功能为付费服务，确保您没有欠费。',
  'user.webhook.function.tip2': '当有关联的司机进行酒精测试后，测试数据将通过https POST请求推送到您设定URL地址。',
  'user.webhook.function.tip3': '推送application/json数据格式如下:',
  'user.webhook.remaining.amount': '当前剩余金额：',
  'user.webhook.remaining.amount.tip': '当前服务为付费项目，价格为每条数据0.05元。为避免数据因金额不足而推送失败，请保证您的账户有足够的剩余金额。',
  'user.webhook.charge': '充值',
  'user.webhook.amount.unit': '元',
  'user.webhook.config.empty': '当前还没有配置Webhook地址',
  'user.webhook.config': '开始配置',
  'user.webhook.config.update': '修改配置',
  'user.webhook.config.mock': '模拟测试',
  'user.webhook.config,info': 'Webhook配置信息',
  'user.webhook.config.url': 'Webhook URL',
  'user.webhook.config.tip': '例：https://example.com/webhook。必须为http或https地址。',
  'user.webhook.config.tip2': 'Webhook地址必须以http://或者https://开头',
  'user.webhook.config.tip3': 'Webhook地址必须经过验证后才能保存。请参考',
  'user.webhook.function.tip6': '开发者服务器在收到数据后，需要返回JSON中的message_id，表明该服务器已正确接收并处理该数据。若开发者服务器未正确回复，ALC Manage服务器将尝试重新发送3次。若3次都失败，该数据将标记为发送失败。若开发者想找回该发送失败的记录，可进入推送记录标签页，找到发送失败的记录，点击重发按钮再次发送数据。',
  'user.webhook.config.check.doc': 'Webhook URL验证文档',
  'user.webhook.config.tip4': '编写一个简单的POST接口，并进行正确的响应。',
  'user.webhook.config.check': '验证',
  'user.webhook.config.check.success': '验证通过',
  'user.webhook.config.check.fail': '接口验证未通过,请再次核对接口与文档是否一致。',
  'user.webhook.config.unit': '数据单位',
  'user.webhook.config.unit.tip': '请根据区域规定选择推送数据的数据单位',
  'user.action.submit': '提交',
  'user.action.submit.url.error': '未验证Webhook URL',
  'user.webhook.config.key': '安全秘钥',
  'user.webhook.config.key.show': '显示',
  'user.webhook.config.key.hide': '隐藏',
  'user.webhook.config.key.gen': '重新生成',
  'user.webhook.config.enable': '启用',
  'user.webhook.config.disable': '禁用',
  'user.webhook.config.tip5': '当前未启用推送，请确保您已经按照右侧文档完成接口开发再启用。',
  'user.webhook.config.mock.sended': '已发送模拟数据',
  'user.webhook.interface.json.reark': '关于json中各字段的说明',
  'api.field.key': '字段',
  'api.field.type': '字段值类型',
  'api.field.desc': '字段说明',
  'user.amount.buy.num.tip': '请选择充值金额',
  'user.amount.charge.custom': '自定义金额',
  'user.amount.buy.pay': '您需要支付：',
  'user.amount.buy.submit': '使用Paypal支付',
  'user.webhook.tab.config': '推送配置',
  'user.webhook.tab.record': '推送记录',
  'user.test.location.not.pro': '要查看详细的GPS位置，请将会员升级为PRO+会员身份。',
  'user.password.tip': '请输入您的登录密码',
  'user.pay.none': '无需支付',
  'user.pay.now': '立即支付',
  'sys.error': '错误',
  'sys.user.info.error': '用户信息请求失败或登录无效。',
  'user.test.location': '测试地点',
  'user.test.video': '录像',
  'user.service.support': '客服支持',
  'user.service.doc': '文档',
  'user.alc.limited.user': '人Pro会员过期，数据不在Excel表格中。',
  'user.alc.xlsx.download.tip': '点击下载当日测试数据',
  'user.email.alert': '邮件推送',
  'user.record.data.syncing': '数据同步中，下载进度：',
  'user.record.data.sync.finish': '数据同步完成',
  'user.bind.delete.multiple': '批量删除',
  'user.membership.upgrade.multiple': '批量升级',
  'user.membership.expire.alert': '{num}名司机的PRO会员过期或即将过期',
  'user.membership.limit.none': '无限制',
  'user.membership.driver.selected': '已选择{num}位司机，',
  'user.membership.show.details': '点击查看详情。',
  'user.membership.upgradeDetail': '会员升级详细信息',
  'user.membership.target.user': '姓名',
  'user.membership.target.level': '升级后会员等级',
  'user.membership.target.expireDate': '升级后会员到期日',
  'user.membership.level.pro': 'Pro会员',
  'user.membership.level.plus': 'Pro+会员',
  'user.membership.level.trial': '试用会员',
  'user.membership.switchTo.pro': '切换为Pro会员',
  'user.membership.switchTo.plus': '切换为Pro+会员',
  'user.membership.pay.success': '支付成功',
  'user.membership.current.trial': '当前：试用会员。',
  'user.membership.current.pro': '当前：Pro会员，有效期至{date}。',
  'user.membership.current.plus': '当前：Pro+会员，有效期至{date}。',
  'user.membership.card.trial': '试用会员（免费）',
  'user.membership.card.pro.monthly': 'Pro会员（{price}元/月）',
  'user.membership.card.pro.yearly': 'Pro会员（{price}元/年）',
  'user.membership.card.plus': 'Pro+会员（{price}元/月）',
  'user.membership.startMonth': '开始月份：',
  'user.membership.monthUnit': '个月',
  'user.membership.expire.notice': '有效期至{date}（以实际支付开通期限为准）',
  'user.membership.total': '合计：',
  'user.membership.currency': '元',
  'user.membership.pricing.desc': '关于功能区别和价格的具体说明，请点击',
  'user.membership.pricing.link': '此处',
  'user.membership.payment.title': '会员支付',
  'user.membership.downgrade.not.support': '当前Pro+会员在到期前不支持降级。',
  'user.action.delete.title': '提示',
  'user.action.delete.content': '确认删除所选司机吗？',
  'user.action.disable': '禁用',
  'user.action.enable': '启用',
  'user.action.disable.batch': '批量禁用',
  'user.action.enable.batch': '批量启用',
  'user.action.disable.batch.title': '提示',
  'user.action.disable.content': '确认禁用所选司机吗？',
  'user.attendance.work': '工作',
  'user.attendance.rest': '休息',
  'user.attendance.work.dur': '工作',
  'user.attendance.rest.dur': '休息',
  'user.checkin.stat': '考勤统计',
  'user.checkin.record': '考勤记录',
  'user.checkin.dur': '出勤时间段',
  'user.checkin.date': '打卡日期',
  'user.checkin.time': '打卡时间',
  'user.checkin.action': '打卡操作',
  'user.checkin.location': '打卡位置',
  'user.checkin.action.clockin': '出勤',
  'user.checkin.action.clockout': '退勤',
  'user.checkin.action.breakstart': '开始休息',
  'user.checkin.action.breakend': '结束休息',
  'user.checkin.export.filename': '考勤记录',
  'user.checkin.export.fail': '导出失败',
  'user.checkin.export': '导出Excel',
  'user.excel.exporting': '正在导出数据...',
  'user.checkin.driver': '司机',
  'user.checkin.stat.date': '统计日期',
  'user.checkin.stat.month': '统计月份',
  'user.checkin.work.dur.real': '实际工作时长',
  'user.checkin.work.dur': '工作时长',
  'user.checkin.rest.dur': '休息时长',
  'user.checkin.stat.single.day': '多人单日统计',
  'user.checkin.stat.more.day': '单人单月统计',
  'user.checkin.stat.expire.tip': '{num}人会员过期，不在统计范围中。您可为会员过期人员开通PRO会员或者免费查看其记录并人工统计。',
  'user.drive.log.start': '开始驾驶',
'user.drive.log.end': '结束驾驶',
  'user.drive.log.time': '时间',
'user.drive.log.address': '地点',
  'user.drive.log.start_address': '出发点',
  'user.drive.log.end_address': '终点',

  // 3D 运行大屏（/dashboard3d）
  'menu.dashboard3d': '仪表盘',
  'db3d.title': '车队运营大屏',
  'db3d.subtitle': '今日检测与出勤实时概览',
  'db3d.refresh': '刷新',
  'db3d.kpi.coverage': '今日检测完成率',
  'db3d.kpi.tested': '今日检测人数',
  'db3d.kpi.limited': '今日超标',
  'db3d.kpi.attendance': '今日出勤',
  'db3d.panel.fleet': '车队状态',
  'db3d.fleet.drivers': '在册司机',
  'db3d.fleet.active': '启用账号',
  'db3d.fleet.idle': '今日未检',
  'db3d.panel.attendance': '今日考勤',
  'db3d.attendance.checkin': '已打卡',
  'db3d.attendance.checkinIdle': '未打卡',
  'db3d.attendance.rate': '出勤率',
  'db3d.panel.day': '选中日期',
  'db3d.day.tested': '检测人数',
  'db3d.day.total': '应检人数',
  'db3d.day.limited': '超标人数',
  'db3d.unit.testNum': '人次',
  'db3d.panel.stream': '实时检测流',
  'db3d.empty.stream': '暂无近期检测记录',
  'db3d.legend.title': '环形柱状 · 近30天检测人数',
  'db3d.legend.normal': '无超标',
  'db3d.range': '趋势区间',
  'db3d.hint': '拖拽旋转 · 滚轮缩放 · 点柱体查看当日',
  'db3d.loading': '数据加载中',
  'db3d.webgl.fail': '当前浏览器不支持 WebGL，无法渲染 3D 场景'
}
